import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80566 1.46344H14.1943",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80566 9.46344H14.1943",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.80566,
			y: 4.03662,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.75,
			y: 4.03662,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.6943,
			y: 4.03662,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.80566,
			y: 12.0366,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.75,
			y: 12.0366,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.6943,
			y: 12.0366,
			width: 2.5,
			height: 2.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgGroup;
